import { Client } from "../context/app";
import { IAppsFields, IInstallation } from "../types/appstore";
import { Setting } from "../types/setting";

export const applyIsInstalledFlag = ({
  apps,
  settings,
  installations,
}: {
  apps: IAppsFields[];
  settings: Setting[];
  installations: IInstallation[];
}): IAppsFields[] => {
  return apps.map((app) => {
    let isInstalled: boolean;

    // Set install values for APPs
    if (app.isLegacy) {
      isInstalled = app.isInstalled = settings.some(
        (setting) =>
          (setting.type === app.settingName &&
            setting.name === "enabled" &&
            setting.value.toString() === "1") ||
          (setting.type === app.settingName &&
            setting.name === "beta_access" &&
            setting.value.toString() === "1"),
      );
    } else {
      isInstalled = installations.some(
        (iapp) =>
          iapp.appId === app.uuid &&
          (iapp.status === "INSTALLED" || iapp.status === "INSTALLING"),
      );
    }
    return {
      ...app,
      isInstalled,
    };
  });
};

export const FEATURED_TYPE_ID = "6UaYfbmA8dPmWb8llssuPA";
export const NEW_TYPE_ID = "6oMsTzWUMDhJnffLR8BXKW";
export const ESSENTIAL_TYPE_ID = "55QvbLy9I6YG6ld2yc6TlS";
export function orderApps(apps: IAppsFields[]): IAppsFields[] {
  const orderedApps: IAppsFields[] = [];

  const orderAppByType = (typeId: string): void => {
    const filteredApps = apps.filter(
      (item) =>
        item.types?.some((type) => type.id === typeId) &&
        !orderedApps.some((oapp) => oapp.id === item.id),
    );

    orderedApps.push(
      ...filteredApps.sort((a, b) => a.name.localeCompare(b.name)),
    );
  };

  orderAppByType(FEATURED_TYPE_ID);
  orderAppByType(NEW_TYPE_ID);
  orderAppByType(ESSENTIAL_TYPE_ID);

  const otherApps = apps
    .filter(
      (item) =>
        !item.types?.some(
          (type) =>
            type.id === FEATURED_TYPE_ID ||
            type.id === NEW_TYPE_ID ||
            type.id === ESSENTIAL_TYPE_ID,
        ),
    )
    .sort((a, b) => a.name.localeCompare(b.name));

  return [...orderedApps, ...otherApps];
}

export const ACH = "pushpress-ach";
export const US_COUNTRY_CODE = 840;
export const AUS_COUNTRY_CODE = 554;
export const ADB = "stripe-au-becs-debit";

interface FilterRule {
  settingName: string;
  countryCode?: number;
  additionalConditions?: (app: IAppsFields, client: Client) => boolean;
}

const filterRules: FilterRule[] = [
  {
    settingName: ACH,
    countryCode: US_COUNTRY_CODE,
  },
  {
    settingName: ADB,
    countryCode: AUS_COUNTRY_CODE,
  },
];

export function filterAppRules(
  apps: IAppsFields[],
  client: Client,
): IAppsFields[] {
  return apps.filter((app) => {
    for (const rule of filterRules) {
      if (app.settingName === rule.settingName) {
        if (rule.countryCode && client.country !== rule.countryCode) {
          return false;
        }

        if (
          rule.additionalConditions &&
          !rule.additionalConditions(app, client)
        ) {
          return false;
        }

        return true;
      }
    }

    return true;
  });
}
